export default __webpack_public_path__ + "static/media/BR.e4671314.svg";